import Vue from 'vue';

export default Vue.extend({
    props: {
        titles: {
            type: Array,
            default() {
                return [
                    {
                        id: 'id',
                        name: 'id',
                        sort: 'desc',
                        visible: true,
                    },
                    {
                        id: 'name',
                        name: 'ФИО',
                        // sort: 'desc',
                        visible: true,
                    },
                    {
                        id: 'email',
                        name: 'E-mail',
                        visible: true,
                    },
                ];
            },
        },
        hidden_columns: {
            type: Array,
            default() {
                return [];
            },
        },
        sort_fields: {
            type: Array,
            default() {
                return ['id'];
            },
        },
        rows: {
            type: Array,
            default() {
                return [
                    {
                        id: 1,
                        name: 'John Snow',
                        email: 'john@wall.com',
                    },
                    {
                        id: 2,
                        name: 'Jamie Lannister',
                        email: 'jamie@lannister.com',
                    },
                ];
            },
        },
        rowsById: {
            type: Object,
        },
        actionsHandler: {
            type: Object,
            default() {
                return {
                    edit: 'edit',
                    delete: 'delete',
                    sort: 'sort',
                };
            },
        },
        routeName: {
            type: String,
        },
        routeParam: {
            type: String,
        },
        routeParamValue: {
            type: String,
        },
        routeParamAdditional: {
            type: String,
        },
        routeParamAdditionalValue: {
            type: String,
        },
        actionPagination: {
            type: String,
        },
        pagination: {
            type: Object,
        },
        isStatusColumn: {
            type: Boolean,
        },
        isEdit: {
            type: Boolean,
        },
        isTotal: {
            type: Boolean,
        },
        colspan: {
            type: Object,
        },
        isBottomTable: {
            type: Boolean,
        },
        alignRightColumn: {
            type: Array,
            default() {
                return [];
            },
        },
        amountItems: {
            type: Number,
        },
        isSettingsState: {
            type: Boolean,
        },
        watchedIds: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            touch: null,
            isExportOpen: false,
            isShowDetails: false,
            detailsId: null,
        };
    },
    methods: {
        actionHandler(name: string, id: string, row?: any) {
            this.$emit('click', { action: name, id, row });
        },
        toggleSort(id: string, sort: string) {
            this.$emit('click', { action: 'sort', field: id, sort });
        },
        handleDragDrop(column: any) {
            this.$emit('handleDragDrop', column);
        },
        selectAmount(amount: number) {
            this.$emit('selectAmount', amount);
        },
    },
});
